import Axios from "axios";
import AppConfig from "@/config/AppConfig";

export default {
  pending(any, apsId) {
    const params = {
      apsId: apsId,
      any: any
    }
    return Axios.get(
      "/bonusCompliance/pending", {
        params: params
      }
    );
  },
  pendingPdf(apsUserName, apsId, agencyName) {
    const params = {
      apsUserName: apsUserName,
      apsId: apsId,
      agencyName: agencyName
    }
    return Axios.get(
      "/bonusCompliance/pendingPdf", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  pendingExcel(apsUserName, apsId, agencyName) {
    const params = {
      apsUserName: apsUserName,
      apsId: apsId,
      agencyName: agencyName
    }
    return Axios.get(
      "/bonusCompliance/pendingExcel", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  preliquidationGeneration(data,apsRuc, apsId, agencyName) {
    const params = {
      agencyName: agencyName,
      apsId: apsId,
      apsRuc: apsRuc,
    }
    return Axios.post(
      "/bonusCompliance/preliquidationGeneration",
      data, {
        params: params
      }
    );
  },
  validatePermission(apsRuc) {
    const params = {
      apsRuc: apsRuc,
    }
    return Axios.get(
      "/bonusCompliance/validatePermission", {
        params: params
      }
    );
  },
  preliquidationApprove(data, apsId, agencyName) {
    const params = {
      agencyName: agencyName,
      apsId: apsId,
    }
    return Axios.post(
      "/bonusCompliance/preliquidationApprove", {
        preliquidationsId: data
      }, {
        params: params
      }
    );
  },
  preliquidationApproveAndBill(data, apsId, agencyName) {
    const params = {
      agencyName: agencyName,
      apsId: apsId
    }
    return Axios.post(
      "/bonusCompliance/preliquidationApproveAndBill", {
        preliquidationsId: data
      }, {
        params: params
      }
    );
  },
  preliquidationReject(data, apsId, agencyName) {
    const params = {
      agencyName: agencyName,
      apsId: apsId,
    }
    return Axios.post(
      "/bonusCompliance/preliquidationReject", {
        preliquidationsId: data
      }, {
        params: params
      }
    );
  },
  preliquidation(any, apsId,agencyName) {
    const params = {
      apsId: apsId,
      agencyName: agencyName,
      any: any
    }
    return Axios.get(
      "/bonusCompliance/preliquidation", {
        params: params
      }
    );
  },
  liquidation(any, apsId) {
    const params = {
      apsId: apsId,
      any: any
    }
    return Axios.get(
      "/bonusCompliance/liquidation", {
        params: params
      }
    );
  },
  bonusCompliancePdf(id) {
    const params = {
      id: id
    }
    return Axios.get(
      "/bonusCompliance/bonusCompliancePdf", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  bonusCompliancePreliminarPdf(id) {
    const params = {
      id: id
    }
    return Axios.get(
      "/bonusCompliance/bonusCompliancePreliminarPdf", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  bonusComplianceExcel(id) {
    const params = {
      id: id
    }
    return Axios.get(
      "/bonusCompliance/bonusComplianceExcel", {
        responseType: 'arraybuffer',
        params: params
      }
    );
  },
  IsUserAgent(userId) {
    return Axios.get(AppConfig.siaerpBaseUrl + `Siaerp/GetAgenteById?idUsuario=${userId}`);
  },
  bonusDetailLiquidation(data)
  {
    const params = {
      nummero: nummero

    }
    return Axios.get(
      "/bonusCompliance/bonusComplianceDetail",{
        params: params
      }
    );
  }
};